// Notes tab: filter pills, composer with share chips, stream-style rows.
import React, { useState } from 'react';
import ActivityRow from './ActivityRow';
import { buildActivity, noteKind } from '../../../lib/conciergeActivityModel';

const FILTERS = [['all', 'All'], ['internal', 'Internal'], ['shared', 'Shared'], ['system', 'System']];

export default function NotesTab({ notes, loading, onAdd }) {
  const [filter, setFilter] = useState('all');
  const [draft, setDraft] = useState('');
  const [vis, setVis] = useState({ visible_to_athlete: false, visible_to_coach: false });
  const [saving, setSaving] = useState(false);
  const now = new Date();
  const shown = (notes || []).filter(n => filter === 'all' || noteKind(n) === filter);
  const items = buildActivity({ notes: shown });
  const toggle = (k) => setVis(v => ({ ...v, [k]: !v[k] }));
  const add = () => {
    const body = draft.trim();
    if (!body) return;
    setSaving(true);
    onAdd(body, vis)
      .then(() => { setDraft(''); setVis({ visible_to_athlete: false, visible_to_coach: false }); })
      .catch(() => {}) // the page shows the error; keep the draft
      .finally(() => setSaving(false));
  };
  return (
    <div className="cn-tabbody">
      <section className="cn-card">
        <div className="cn-card__head">
          <h2 className="cn-card__title">Notes</h2>
          <span className="cn-card__sub">Internal by default — share per note</span>
          <div className="cn-fpills">
            {FILTERS.map(([id, label]) => (
              <button key={id} type="button" className={`cn-fpill${filter === id ? ' cn-fpill--on' : ''}`}
                aria-pressed={filter === id} onClick={() => setFilter(id)}>{label}</button>
            ))}
          </div>
        </div>
        <div className="cn-composer2">
          <textarea className="cn-textarea" rows={3} placeholder="Write a note…" value={draft}
            onChange={e => setDraft(e.target.value)} />
          <div className="cn-composer2__foot">
            <span className="cn-composer2__label">Share with:</span>
            <button type="button" aria-pressed={vis.visible_to_athlete}
              className={`cn-chip-t${vis.visible_to_athlete ? ' cn-chip-t--on' : ''}`}
              onClick={() => toggle('visible_to_athlete')}>Athlete/Guardian</button>
            <button type="button" aria-pressed={vis.visible_to_coach}
              className={`cn-chip-t${vis.visible_to_coach ? ' cn-chip-t--on' : ''}`}
              onClick={() => toggle('visible_to_coach')}>Coach</button>
            <button type="button" className="cn-pbtn cn-composer2__send" onClick={add}
              disabled={saving || !draft.trim()}>Add note</button>
          </div>
        </div>
        {loading ? <div className="cn-loading">Loading…</div>
          : items.length === 0 ? <div className="cn-empty-line">No notes yet.</div>
            : items.map(it => <ActivityRow key={it.id} item={it} now={now} wide />)}
      </section>
    </div>
  );
}
